import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Submission } from '../../assignment/shared/submission';
import { NgUserService } from '../../core/ng-user.service';
import { LtiMember } from '../shared/lti-member';

@Injectable({
  providedIn: 'root'
})
export class LtiService {

  readonly STUDENT_ROLE = "Learner";

  constructor(private http : HttpClient, private user : NgUserService) { }

  isOn = () : boolean => this.getCourseCode()?.length > 0;

  getMembers = () : Observable<LtiMember[]> => this.http.get<LtiMember[]>(`../rl/lti/members`);
  
  getStudents = () : Observable<LtiMember[]> => new Observable(s => this.getMembers().subscribe(m => s.next(m.filter(m => this.isStudent(m)))));

  getUser = (userId : string) : Observable<LtiMember> => new Observable(s => this.getMembers().subscribe(m => s.next(m.find(m => m.user_id == userId))));

  postGrades = (asgmtId : string) : Observable<Submission[]> => this.http.post<Submission[]>(`../rl/lti/grades/${asgmtId}/submit`, {});

  isStudent = (user : LtiMember) => user.roles.some(r => r.indexOf(this.STUDENT_ROLE) > -1);

  getCourseCode = () : string => this.user.user["lti-coursecode"];

  getLMSSystemName = () : string => {
    let lmsSystem = this.user.user?.ltiSystemType?.toLowerCase();
    return lmsSystem.charAt(0).toUpperCase() + lmsSystem.substr(1);
  }
  // && LTI_TYPE_ARR.indexOf(user.ltiSystemType)> -1){  
}
